import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  fullWidth = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-none font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none tracking-wide uppercase text-sm';
  const variants = {
    primary: 'bg-brand-gold text-white hover:bg-[#b0913e] focus:ring-brand-gold shadow-md hover:shadow-lg',
    secondary: 'bg-brand-dark text-white hover:bg-black focus:ring-brand-dark',
    outline: 'border-2 border-white text-white hover:bg-white hover:text-brand-dark focus:ring-white',
    ghost: 'bg-transparent text-brand-dark hover:bg-brand-light'
  };
  const sizes = {
    sm: 'h-9 px-4 text-xs',
    md: 'h-12 px-8',
    lg: 'h-14 px-10 text-base'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-182">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-183" />}
      {children}
    </button>;
}